export const calculateOffset = (page: number, itemsPerPage: number): number => (page - 1) * itemsPerPage;
